export const protocol_set = {
  Download_complete_and_detailed_mapping_file: "Baixar arquivo de mapeamento completo e detalhado",
  Download_complete_and_simplified_mapping_file: "Baixar arquivo de mapeamento completo e simplificado",
  Download_filtered_and_simplified_mapping_file: "Baixar arquivo de mapeamento filtrado e simplificado",
  Draft_Name: "Nome do Rascunho",
  protocol_question: {
    Are_you_sure_you_want_to_delete_this_protocol_question:
      "Tem certeza de que deseja excluir esta questão de protocolo?",
    are_you_sure_you_want_to_duplicate_this_protocol_question:
      "Tem certeza de que deseja duplicar esta questão de protocolo?",
    Basic_information: "Informações básicas",
    changed: "alterado",
    Content: "Conteúdo",
    Content_is_required: "Conteúdo é obrigatório",
    Create_protocol_question: "Criar nova questão de protocolo",
    created: "criado",
    deleted: "excluído",
    erm_mapping_note: "Nota de Mapeamento ERM",
    Export_to_file: "Exportar para arquivo",
    Internal_audit: "Auditoria interna",
    Link_a_requirement: "Vincular um requisito",
    link_a_protocol_question: "Vincular uma questão de protocolo",
    link_protocol_questions: {
      Back_to_Linking_Page: "Voltar para a Página de Vinculação",
      Back_to_the_Protocol_Questions_List: "Voltar para a Lista de Questões de Protocolo",
      Back_to_the_Requirements_List: "Voltar para a Lista de Requisitos",
      Link_protocol_questions_to_requirements: "Vincular questões de protocolo a um requisito",
      Requirement_info: "Requisito",
      This_requirement_is_already_mapped_to: "Este requisito já está mapeado para:",
    },
    link_requirements: {
      Is_mapped: "Está mapeado",
      Link: "Vincular",
      Name_of_the_standard: "Nome do padrão",
      Protocol_question_is_in_edit_mode: "Questão de protocolo está em modo de edição, as alterações não serão salvas.",
      Search_results: "Resultados da pesquisa",
      Search_similarities_in_protocol_questions: "Pesquisar similaridades em questões de protocolo",
      Select_filters: "Selecionar filtros",
      Smart_search_mode: "Modo de pesquisa inteligente",
      You_have_to_select_at_least_one_requirement: "Você deve selecionar pelo menos um requisito",
    },
    internal_note: "Nota interna de SME",
    Link_requirements: "Vincular requisitos",
    linked: "vinculado",
    List_of_mapped_requirements: "Lista de requisitos mapeados",
    list_of_related_protocol_questions: "Lista de questões de protocolo relacionadas",
    Protocol_question: "Questão de protocolo",
    Protocol_question_info: "Informações da questão de protocolo",
    Protocol_question_list: "Lista de questões de protocolo",
    reorder: {
      No_protocol_questions_found_for_this_theme_and_subtheme:
        "Nenhuma questão de protocolo encontrada para este tema e subtema.",
      Reorder: "Reordenar",
      Reorder_protocol_questions: "Reordenar questões de protocolo",
      You_need_to_select_a_theme_and_subtheme:
        "Você precisa selecionar um tema e subtema para reordenar questões de protocolo.",
      You_want_to_proceed_without_saving_changes:
        "Você quer prosseguir sem salvar? Todas as alterações serão perdidas.",
    },
    Requirement_will_be_unlinked_from_the_protocol_question: "O requisito será desvinculado da questão de protocolo.",
    protocol_questions_will_be_unlinked: "Questões de protocolo serão desvinculadas",
    Save_protocol_question: "Salvar questão de protocolo",
    Scope_of_applicability: "Escopo de aplicabilidade",
    Scope_of_applicability_is_required: "Escopo de aplicabilidade é obrigatório",
    split: "dividir",
    Stakeholder_engagement: "Engajamento das partes interessadas",
    Standard_structure: "Estrutura do padrão",
    Start_a_new_draft: "Iniciar um novo rascunho",
    Sub_theme_is_required: "Subtema é obrigatório",
    Subtheme: "Subtema",
    Theme: "Tema",
    Theme_is_required: "Tema é obrigatório",
    This_action_cannot_be_undone: "Esta ação não pode ser desfeita",
    This_file_will_contain_all_protocol_questions_in_this_mapping_set:
      "Este arquivo conterá todas as questões de protocolo neste conjunto de mapeamento.",
    This_file_will_contain_protocol_questions_based_on_all_the_customizations_and_filters_you_have_applied:
      "Este arquivo conterá questões de protocolo com base em todas as personalizações e filtros que você aplicou.",
    This_mapping_draft_is_currently_in_review:
      "Este rascunho de mapeamento está atualmente em revisão. Fazer esta alteração cancelará o status de revisão do rascunho.",
    This_protocol_question_is_also_linked_to: "Esta questão de protocolo também está vinculada a",
    Unlink: "Desvincular",
    unlinked: "desvinculado",
    You_will_be_redirected_to_the_newly_created_protocol_question:
      "Você será redirecionado para a questão de protocolo recém-criada.",
  },
  Protocol_Question: "Questão de Protocolo",
  Protocol_questions: "Questões de Protocolo",
  Protocol_set: "Conjunto de Protocolo",
  question_id: "ID da Questão",
  related_requirements: "Requisitos Relacionados",
  review_draft: {
    Approve_and_close: "Aprovar e fechar",
    Are_you_sure_you_want_to_publish_this_draft: "Tem certeza de que deseja publicar este rascunho?",
    at: "às",
    Created_by: "Criado por",
    Download_draft_changes: "Baixar alterações do rascunho",
    Draft_cannot_be_published_by_the_same_user:
      "O rascunho não pode ser publicado pelo mesmo usuário que o enviou para revisão.",
    Draft_has_already_been_submitted: "O rascunho já foi enviado para aprovação.",
    Draft_needs_to_be_submitted_for_review_before_publishing:
      "O rascunho precisa ser enviado para revisão antes da publicação.",
    Draft_review: "Revisão do rascunho",
    No_further_edits_will_be_possible_after_publishing: "Nenhuma edição adicional será possível após a publicação.",
    on: "em",
    page_description: {
      Note: "Nota: Enquanto estiver no estado de aprovação pendente, quaisquer alterações adicionais em uma questão de protocolo no rascunho reverterão o estado de aprovação pendente.",
      Please_press_download_draft:
        'Pressione "Baixar alterações do rascunho" para obter uma representação em Excel das alterações de mapeamento de protocolo entre este rascunho e a última versão publicada.',
      The_flow_for_mapping:
        "O fluxo para alterações de mapeamento é o seguinte: Rascunho -> Aprovação Pendente -> Publicar.",
      This_is_the_page_for_draft:
        "Esta é a página para revisão e aprovação de rascunho. Uma vez aprovado por outro usuário da ferramenta de mapeamento, o rascunho será publicado, tornando-o salvo sem possibilidade de alterações adicionais.",
    },
    Published_by: "Publicado por",
    Review_a_draft: "Revisar um rascunho",
    Submit_for_approval: "Enviar para aprovação",
    Submitted_by: "Enviado por",
  },
  scope_of_applicability: "Escopo de aplicabilidade",
  Search_protocol_questions: "Pesquisar questões de protocolo",
  Search_requirements: "Pesquisar requisitos",
  Search_standards: "Pesquisar padrões",
  standards: {
    Add_New_Standard: "Adicionar Novo Padrão",
    All_Clients: "Todos os Clientes",
    Back_to_the_Standards_List: "Voltar para a Lista de Padrões",
    Body: "Órgão",
    Create_New_Standard: "Criar Novo Padrão",
    Date: "Data",
    Edit_Standard: "Editar Padrão",
    Full_name: "Nome completo",
    ID: "ID",
    Link: "Link",
    Publish_date: "Data de publicação",
    Save_Standard: "Salvar Padrão",
    Standard_body: "Órgão do padrão",
    Standard_ID: "ID do Padrão",
    Tenants: "Locatários",
    Version: "Versão",
  },
  Start_a_draft: "Iniciar um rascunho",
  Start_draft_description: "Iniciar um novo rascunho e mudar para o modo de edição",
  Starting_new_draft_process: "Iniciando Novo Processo de Rascunho",
  sub_theme: "Subtema",
  theme: "Tema",
} as const;
